
import { Option as Option_1, div } from "../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { find, filter, head, tail, exists, cons, map, isEmpty, ofArrayWithTail, item, mapIndexed, max, truncate, map2, initialize, append, getSlice, length, singleton, ofArray, empty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { fieldLabel } from "./PropertiesHelp.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Prop, DOMAttr, HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { confirmationPopup, preventDefault } from "../DrawBlock/PopupHelpers.js";
import { getFloatEventValue, getIntEventValue, getBigintEventValue, getTextEventValue } from "../Interface/JSHelpers.js";
import * as react_2 from "react";
import { uncurry2, compare, comparePrimitives, int32ToString, defaultOf, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { value as value_2, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { toFail, concat, printf, toText } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { Option as Option_2, label as label_1 } from "../fable_modules/Fulma.3.0.0/Elements/Form/Label.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { removeFileWithExtn, pathJoin, tryReadFileSync, openWriteDialogAndWriteMemory, initialiseMem, fileExistsWithExtn } from "../Interface/FilesIO.js";
import { Common_GenericOption, Modifier_IModifier, Color_IColor, Size_ISize } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { makePopupButton, memPropsInfoButton, bSpan } from "./UIPopups.js";
import { fromZero, fromInt32, fromOne, op_LeftShift, toUInt64_unchecked } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { viewParameters, makeParamBindingEntryBoxes, paramBindingsOfModel, paramInputField } from "./ParameterView.js";
import { constraintsFor } from "../Common/ComponentSlots.js";
import { CompSlotName } from "../Common/ParameterTypes.js";
import { HighLightColor, ComponentType, Project, $007CMemory$007C_$007C } from "../Common/CommonTypes.js";
import { Model, FileCommandType, UICommandType, Msg } from "../Model/ModelType.js";
import { Option as Option_3, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { openMemoryEditor } from "./MemoryEditorView.js";
import { errorPropsNotification, successPropertiesNotification } from "./Notifications.js";
import { setComponentLabel, openFileInProject, removeFileInProject, makeSourceMenu } from "./MenuHelpers.js";
import { DrawModelType_SheetT_Model__Model_ChangeReversedInputs, DrawModelType_SheetT_Model__Model_ChangeSplitN, DrawModelType_SheetT_Model__Model_ChangeMergeN, DrawModelType_SheetT_Model__Model_ChangeGate, DrawModelType_SheetT_Model__Model_ChangeScale, DrawModelType_SheetT_Model__Model_ChangeCounterComp, DrawModelType_SheetT_Model__Model_ChangeAdderComp, DrawModelType_SheetT_Model__Model_UpdateMemory } from "../DrawBlock/Sheet.js";
import { DrawModelType_BusWireT_Msg, DrawModelType_SheetT_Msg } from "../Model/DrawModelType.js";
import { createSheetDescriptionPopup, busCompareValueMessage, constantValueMessage, Constants_maxSplitMergeBranches, Constants_maxGateInputs, createVerilogPopup } from "./CatalogueView.js";
import { CodeEditorOpen } from "../VerilogComponent/VerilogTypes.js";
import { table as table_1 } from "../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { input as input_1 } from "../fable_modules/Fulma.3.0.0/Elements/Form/Checkbox.fs.js";
import { signatureOfInstance } from "../Simulator/CanvasExtractor.js";
import { openSheetIsReadOnly, getUpdatedLoadedComponents } from "./ModelHelpers.js";
import { FSharpMap__get_Item, toList, tryFind, empty as empty_1 } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { StringModule_StartsWithLetter, StringModule_Length, StringModule_Concat } from "../Common/EEExtensions.js";
import { menuLabelStyle } from "./Style.js";
import { displayedComponent, extractComponent } from "../DrawBlock/SymbolUpdate.js";
import { indexed, filter as filter_1, map as map_1 } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { isLetterOrDigit } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { toString } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { viewArraySettings } from "./ArraySheetView.js";

export const Constants_labelUniqueMess = "Components must have a unique label within one sheet";

export const Constants_dropDownHeightFraction = 2.5;

function textFormField(isRequired, name, defaultValue, isBad, onChange) {
    let props_2, children;
    return div(empty(), ofArray([fieldLabel(name), input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Props */ 15, [ofArray([new HTMLAttr(/* Id */ 99, ["labelInputElement"]), new DOMAttr(/* OnPaste */ 2, [(e) => {
        preventDefault(e);
    }]), new HTMLAttr(/* SpellCheck */ 148, [false]), new HTMLAttr(/* Name */ 123, [name]), ["style", {
        width: "200px",
    }]])]), new Option(/* DefaultValue */ 10, [defaultValue]), new Option(/* Placeholder */ 12, [isRequired ? "required" : "optional"]), new Option(/* OnChange */ 13, [(arg) => {
        onChange(getTextEventValue(arg));
    }])])), react_2.createElement("br", {}), (props_2 = [["style", {
        fontStyle: "Italic",
        color: "Red",
    }], new HTMLAttr(/* Hidden */ 92, [equals(isBad, undefined)])], (children = [defaultArg(isBad, "")], react_2.createElement("span", keyValueList(props_2, 1), ...children)))]));
}

function textFormFieldSimple(name, defaultValue, onChange) {
    return div(empty(), ofArray([fieldLabel(name), input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
        preventDefault(e);
    }]), new HTMLAttr(/* SpellCheck */ 148, [false]), new HTMLAttr(/* Name */ 123, [name]), ["style", {
        width: "200px",
    }]])]), new Option(/* DefaultValue */ 10, [defaultValue]), new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* OnChange */ 13, [(arg) => {
        onChange(getTextEventValue(arg));
    }])]))]));
}

function intFormField(name, width, defaultValue, minValue, onChange) {
    return div(empty(), ofArray([fieldLabel(name), input(ofArray([new Option(/* Type */ 1, [IInputType.Number$]), new Option(/* Props */ 15, [ofArray([["style", {
        width: width,
    }], new HTMLAttr(/* Min */ 119, [minValue])])]), new Option(/* DefaultValue */ 10, [toText(printf("%A"))(defaultValue)]), new Option(/* OnChange */ 13, [(arg_1) => {
        onChange(getBigintEventValue(arg_1));
    }])]))]));
}

function intFormField2(name, bits, width, defaultValue1, defaultValue2, minValue1, minValue2, onChange1, onChange2) {
    return div(singleton(new Option_1(/* Props */ 11, [singleton(["style", {
        display: "flex",
        alignItems: "center",
    }])])), ofArray([label_1(singleton(new Option_2(/* Props */ 3, [singleton(["style", {
        width: "115px",
        flex: "0 0 auto",
    }])])), singleton(name)), label_1(singleton(new Option_2(/* Props */ 3, [singleton(["style", {
        textAlign: "center",
        width: "50px",
        marginRight: "8px",
    }])])), singleton(bits)), input(ofArray([new Option(/* Type */ 1, [IInputType.Number$]), new Option(/* Props */ 15, [ofArray([["style", {
        width: width,
    }], new HTMLAttr(/* Min */ 119, [minValue1])])]), new Option(/* DefaultValue */ 10, [toText(printf("%d"))(defaultValue1)]), new Option(/* OnChange */ 13, [(arg_1) => {
        onChange1(getIntEventValue(arg_1));
    }])])), input(ofArray([new Option(/* Type */ 1, [IInputType.Number$]), new Option(/* Props */ 15, [ofArray([["style", {
        width: width,
        marginLeft: "15px",
    }], new HTMLAttr(/* Min */ 119, [minValue2])])]), new Option(/* DefaultValue */ 10, [toText(printf("%d"))(defaultValue2)]), new Option(/* OnChange */ 13, [(arg_3) => {
        onChange2(getIntEventValue(arg_3));
    }])])), react_2.createElement("hr", {})]));
}

function floatFormField(name, width, defaultValue, minValue, onChange) {
    return div(empty(), ofArray([fieldLabel(name), input(ofArray([new Option(/* Type */ 1, [IInputType.Number$]), new Option(/* Props */ 15, [ofArray([["style", {
        width: width,
    }], new HTMLAttr(/* Min */ 119, [minValue])])]), new Option(/* DefaultValue */ 10, [toText(printf("%A"))(defaultValue)]), new Option(/* OnChange */ 13, [(arg_1) => {
        onChange(getFloatEventValue(arg_1));
    }])]))]));
}

const clockNote = "Implicitly connected to the global clock.";

/**
 * The kind of component this is, in the words a user would use for it.
 * 
 * Not Symbol.getComponentLegend, which is the text drawn inside the symbol: that bakes in bit
 * counts and rotation, and the pane shows the width in its own box right below.
 * Legacy types are named rather than refused. This renders above everything else in the pane, so
 * a component that cannot be named must not take the whole pane down with it.
 */
export function componentTypeName(ct) {
    let matchResult, gateType, n, custom;
    switch (ct.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 50: {
            matchResult = 2;
            break;
        }
        case 51: {
            matchResult = 3;
            break;
        }
        case 52: {
            matchResult = 4;
            break;
        }
        case 53: {
            matchResult = 5;
            break;
        }
        case 54: {
            matchResult = 6;
            break;
        }
        case 55: {
            matchResult = 7;
            break;
        }
        case 2: {
            matchResult = 8;
            break;
        }
        case 3: {
            matchResult = 9;
            break;
        }
        case 4: {
            matchResult = 10;
            break;
        }
        case 7:
        case 49: {
            matchResult = 11;
            break;
        }
        case 6: {
            matchResult = 12;
            break;
        }
        case 47:
        case 5: {
            matchResult = 13;
            break;
        }
        case 8: {
            matchResult = 14;
            break;
        }
        case 9: {
            matchResult = 16;
            break;
        }
        case 11:
        case 12:
        case 13: {
            matchResult = 17;
            break;
        }
        case 14:
        case 15:
        case 16: {
            matchResult = 18;
            break;
        }
        case 17:
        case 18:
        case 19:
        case 20: {
            matchResult = 19;
            break;
        }
        case 22: {
            matchResult = 22;
            break;
        }
        case 24: {
            matchResult = 23;
            break;
        }
        case 23: {
            matchResult = 24;
            break;
        }
        case 25: {
            matchResult = 25;
            break;
        }
        case 27:
        case 29: {
            matchResult = 26;
            break;
        }
        case 28:
        case 30: {
            matchResult = 27;
            break;
        }
        case 31: {
            matchResult = 28;
            break;
        }
        case 32: {
            matchResult = 29;
            break;
        }
        case 33: {
            matchResult = 30;
            break;
        }
        case 34: {
            matchResult = 31;
            break;
        }
        case 35:
        case 36:
        case 37:
        case 38: {
            matchResult = 32;
            break;
        }
        case 39:
        case 43: {
            matchResult = 33;
            break;
        }
        case 40:
        case 44: {
            matchResult = 34;
            break;
        }
        case 41:
        case 45: {
            matchResult = 35;
            break;
        }
        case 42: {
            matchResult = 36;
            break;
        }
        case 10: {
            matchResult = 15;
            gateType = ct.fields[0];
            n = ct.fields[1];
            break;
        }
        case 21: {
            if (ct.fields[1] != null) {
                matchResult = 20;
            }
            else {
                matchResult = 21;
            }
            break;
        }
        case 46: {
            switch (ct.fields[2].tag) {
                case 1: {
                    matchResult = 38;
                    break;
                }
                case 2: {
                    matchResult = 39;
                    break;
                }
                default:
                    matchResult = 37;
            }
            break;
        }
        case 26: {
            matchResult = 40;
            custom = ct.fields[0];
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return "Input";
        case 1:
            return "Output";
        case 2:
            return "Bus output";
        case 3:
            return "Array output";
        case 4:
            return "Join out";
        case 5:
            return "Join in";
        case 6:
            return "Array bus merge";
        case 7:
            return "Array multiplexer";
        case 8:
            return "Viewer";
        case 9:
            return "Net label";
        case 10:
            return "Not connected";
        case 11:
            return "Constant";
        case 12:
            return "Bus selection";
        case 13:
            return "Bus compare";
        case 14:
            return "Not gate";
        case 15: {
            const gate = `${gateType}`;
            return `${n}-input ${gate.slice(0, 0 + 1).toLocaleUpperCase() + gate.slice(1, gate.length)} gate`;
        }
        case 16:
            return "Decoder";
        case 17:
            return "Multiplexer";
        case 18:
            return "Demultiplexer";
        case 19:
            return "Adder";
        case 20:
            return "Multiplier";
        case 21:
            return "Xor-N block";
        case 22:
            return "And-N block";
        case 23:
            return "Or-N block";
        case 24:
            return "Not-N block";
        case 25:
            return "Bus spreader";
        case 26:
            return "Merge";
        case 27:
            return "Split";
        case 28:
            return "D flip-flop";
        case 29:
            return "D flip-flop with enable";
        case 30:
            return "Register";
        case 31:
            return "Register with enable";
        case 32:
            return "Counter";
        case 33:
            return "Asynchronous ROM";
        case 34:
            return "Synchronous ROM";
        case 35:
            return "Synchronous RAM";
        case 36:
            return "Asynchronous-read RAM";
        case 37:
            return "Shift left";
        case 38:
            return "Shift right";
        case 39:
            return "Arithmetic shift right";
        default:
            return custom.Name;
    }
}

function asHeading(name) {
    if (name === "") {
        return "";
    }
    else {
        return name[0].toLocaleUpperCase() + name.slice(1, name.length);
    }
}

function makeComponentHeader(comp) {
    let props, tag_1, props_2;
    let patternInput;
    const matchValue = comp.Type;
    if (matchValue.tag === 26) {
        const custom = matchValue.fields[0];
        const matchValue_1 = custom.Form;
        let matchResult, compName, libName, vName;
        if (matchValue_1 != null) {
            switch (matchValue_1.tag) {
                case 1: {
                    matchResult = 0;
                    compName = matchValue_1.fields[1];
                    libName = matchValue_1.fields[0];
                    break;
                }
                case 4: {
                    matchResult = 1;
                    vName = matchValue_1.fields[0];
                    break;
                }
                default:
                    matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
        switch (matchResult) {
            case 0: {
                patternInput = [asHeading(compName), concat("library · ", libName)];
                break;
            }
            case 1: {
                patternInput = [asHeading(vName), "Verilog"];
                break;
            }
            default:
                patternInput = [asHeading(custom.Name), "instance of sheet"];
        }
    }
    else {
        patternInput = [componentTypeName(matchValue), undefined];
    }
    const origin = patternInput[1];
    const props_4 = [["style", {
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        marginBottom: "12px",
    }]];
    const children_4 = [(props = [["style", {
        fontWeight: "bold",
        fontSize: "1.125rem",
    }]], react_2.createElement("span", keyValueList(props, 1), patternInput[0])), (origin != null) ? ((tag_1 = origin, (props_2 = [["style", {
        fontSize: "11px",
        color: "grey",
        marginLeft: "8px",
        whiteSpace: "nowrap",
    }]], react_2.createElement("span", keyValueList(props_2, 1), tag_1)))) : defaultOf()];
    return react_2.createElement("div", keyValueList(props_4, 1), ...children_4);
}

export function getInitSource(mem, model) {
    const a = mem.AddressWidth | 0;
    let path;
    const matchValue = model.CurrentProj;
    path = ((matchValue == null) ? "" : matchValue.ProjectPath);
    const matchValue_1 = mem.Init;
    let matchResult, name;
    switch (matchValue_1.tag) {
        case 4: {
            matchResult = 1;
            break;
        }
        case 0: {
            matchResult = 2;
            break;
        }
        case 1: {
            matchResult = 3;
            name = matchValue_1.fields[0];
            break;
        }
        case 2: {
            matchResult = 3;
            name = matchValue_1.fields[0];
            break;
        }
        case 3: {
            matchResult = 3;
            name = matchValue_1.fields[0];
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new FSharpResult$2(/* Ok */ 0, [`Dout = (signed) addr(${a - 1}:${~~(a / 2)}) * addr(${~~(a / 2) - 1}:0)`]);
        case 1:
            return new FSharpResult$2(/* Ok */ 0, [`Dout = (unsigned) addr(${a - 1}:${~~(a / 2)}) * addr(${~~(a / 2) - 1}:0)`]);
        case 2:
            return new FSharpResult$2(/* Ok */ 0, ["Memory Viewer/Editor"]);
        default:
            if (fileExistsWithExtn(".ram", path, name)) {
                const matchValue_2 = initialiseMem(mem, path);
                if (matchValue_2.tag === 1) {
                    return new FSharpResult$2(/* Error */ 1, [concat("From \'", name, ".ram\' file. WARNING - this file exists but has a read error: ", matchValue_2.fields[0])]);
                }
                else {
                    return new FSharpResult$2(/* Ok */ 0, [concat("From \'", name, ".ram\' file")]);
                }
            }
            else {
                return new FSharpResult$2(/* Error */ 1, [`From '${name}.ram' file in folder '${path}'. WARNING - this file does not exist`]);
            }
    }
}

export function getDialogMemorySetup(mem) {
    let matchValue;
    return [mem.AddressWidth, mem.WordWidth, mem.Init, (matchValue = mem.Init, (matchValue.tag === 1) ? matchValue.fields[0] : undefined)];
}

function memoryFacts(mem1, cType, model) {
    let sourceLine;
    let patternInput;
    const matchValue = getInitSource(mem1, model);
    patternInput = ((matchValue.tag === 0) ? [false, matchValue.fields[0]] : [true, matchValue.fields[0]]);
    const msg = concat((cType.tag === 41) ? "Initial " : ((cType.tag === 42) ? "Initial " : ((cType.tag === 40) ? "" : ((cType.tag === 39) ? "" : toFail(`What - wrong component type (${cType}) here`)))), "data source: ", patternInput[1]);
    sourceLine = (patternInput[0] ? label_1(ofArray([new Option_2(/* Size */ 0, [Size_ISize.IsSmall]), new Option_2(/* Modifiers */ 4, [singleton(new Modifier_IModifier(/* TextColor */ 1, [Color_IColor.IsDanger]))])]), singleton(msg)) : label_1(empty(), singleton(msg)));
    return ofArray([bSpan(`Address width: ${mem1.AddressWidth} bit(s)`), react_2.createElement("br", {}), bSpan(`Number of elements: ${toUInt64_unchecked(op_LeftShift(1n, mem1.AddressWidth))}`), react_2.createElement("br", {}), bSpan(`Word width: ${mem1.WordWidth} bit(s)`), react_2.createElement("br", {}), sourceLine]);
}

function makeMemoryWidthFields(model, comp, mem, dispatch) {
    const widthField = (prompt, slot, width) => paramInputField(model, prompt, fromOne(), fromInt32(width), undefined, constraintsFor(slot, comp.Type), undefined, comp, slot, dispatch);
    const children = [widthField("Address width (bits)", CompSlotName.MemoryAddressWidth, mem.AddressWidth), widthField("Data width (bits)", CompSlotName.MemoryWordWidth, mem.WordWidth)];
    return react_2.createElement("div", {}, ...children);
}

function memoryActions(mem, compId, cType, model, dispatch) {
    let activePatternResult, mem_1;
    const setup = getDialogMemorySetup(mem);
    const mem1 = (activePatternResult = $007CMemory$007C_$007C(cType), (activePatternResult != null) ? ((mem_1 = activePatternResult, mem_1)) : toFail(printf("What? memoryActions called with non-memory")));
    if (equals(model.PopupDialogData.MemorySetup, undefined)) {
        dispatch(new Msg(/* SetPopupDialogMemorySetup */ 68, [setup]));
    }
    const projectPath = value_2(model.CurrentProj).ProjectPath;
    const children = [button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_3(/* OnClick */ 18, [(_arg) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, _arg_1) => {
            openMemoryEditor(mem1, compId, model_1, dispatch);
        }, dispatch]));
    }])]), singleton("View/Edit memory content")), memPropsInfoButton(dispatch), react_2.createElement("br", {}), button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_3(/* OnClick */ 18, [(_arg_2) => {
        const _arg_3 = openWriteDialogAndWriteMemory(mem1, projectPath);
        if (_arg_3 != null) {
            dispatch(new Msg(/* SetPropertiesNotification */ 83, [successPropertiesNotification(concat("Memory content written to \'", _arg_3, "\'"))]));
        }
    }])]), singleton("Export memory initial data to file")), react_2.createElement("br", {}), makePopupButton("Memory Initial Data Source", (modelCurrent) => makeSourceMenu(model, (compId_1, mem_2) => {
        DrawModelType_SheetT_Model__Model_UpdateMemory(model.Sheet, (sMsg) => {
            dispatch(new Msg(/* Sheet */ 3, [sMsg]));
        }, compId_1, mem_2);
    }, compId, dispatch, modelCurrent), "Change data source", dispatch)];
    return react_2.createElement("div", {}, ...children);
}

export function makeVerilogEditButton(model, custom, dispatch) {
    const matchValue_1 = model.CurrentProj;
    if (matchValue_1 != null) {
        const project = matchValue_1;
        const matchValue_2 = custom.Form;
        let matchResult, name_1;
        if (matchValue_2 != null) {
            if (matchValue_2.tag === 4) {
                matchResult = 0;
                name_1 = matchValue_2.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                let code_1;
                const matchValue_3 = tryReadFileSync(pathJoin([project.ProjectPath, name_1 + ".v"]));
                code_1 = ((matchValue_3.tag === 1) ? toText(printf("Error: file {%s.v} has been deleted from the project directory"))(name_1) : matchValue_3.fields[0]);
                const children = [react_2.createElement("br", {}), button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_3(/* OnClick */ 18, [(_arg) => {
                    let name, matchValue, proj;
                    dispatch(new Msg(/* StartUICmd */ 109, [UICommandType.SaveSheet]));
                    dispatch(new Msg(/* FileCommand */ 111, [FileCommandType.FileSaveOpenFile, dispatch]));
                    dispatch(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.DoNothing]));
                    ((name = name_1, (new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, (matchValue = model.CurrentProj, (matchValue == null) ? toFail(printf("Can\'t happen!")) : ((proj = matchValue, new Project(proj.ProjectPath, proj.OpenFileName, custom.Name, proj.LoadedComponents)))), model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState), (dispatch_1) => {
                        createVerilogPopup(model, true, code_1, name, new CodeEditorOpen(/* UpdateVerilogFile */ 1, [name]), dispatch_1);
                    })))(dispatch);
                }])]), singleton("View/Edit Verilog code")), react_2.createElement("br", {})];
                return react_2.createElement("div", {}, ...children);
            }
            default:
                return defaultOf();
        }
    }
    else {
        return toFail(printf("What? current project cannot be None at this point in writing Verilog Component"));
    }
}

export function makeVerilogDeleteButton(model, custom, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const matchValue_1 = custom.Form;
        let matchResult, name;
        if (matchValue_1 != null) {
            if (matchValue_1.tag === 4) {
                matchResult = 0;
                name = matchValue_1.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                let body;
                const children = ["Are you sure you want to delete the following Verilog component?", react_2.createElement("br", {}), pathJoin([project.ProjectPath, name + ".v"]), react_2.createElement("br", {}), "This action is irreversible."];
                body = react_2.createElement("div", {}, ...children);
                const children_2 = [react_2.createElement("br", {}), button(ofArray([Option_3.IsOutlined, new Option_3(/* Color */ 0, [Color_IColor.IsDanger]), new Option_3(/* OnClick */ 18, [(_arg_1) => {
                    confirmationPopup("Delete sheet", "Delete", body, () => {
                        dispatch(new Msg(/* StartUICmd */ 109, [UICommandType.DeleteSheet]));
                        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, dispatch_1) => {
                            removeFileInProject(name, project, model_1, dispatch_1);
                        }, dispatch]));
                        removeFileWithExtn(".v", project.ProjectPath, name);
                        dispatch(Msg.ClosePopup);
                    }, dispatch);
                }])]), singleton("Delete")), react_2.createElement("br", {})];
                return react_2.createElement("div", {}, ...children_2);
            }
            default:
                return defaultOf();
        }
    }
    else {
        return toFail(printf("What? current project cannot be None at this point in writing Verilog Component"));
    }
}

function changeAdderType(model, comp, dispatch) {
    let children_4, props, props_2, children_2, children_10, props_6, props_8, children_8;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const sheetDispatch = (sMsg) => {
            dispatch(new Msg(/* Sheet */ 3, [sMsg]));
        };
        let patternInput;
        const matchValue_1 = comp.Type;
        patternInput = ((matchValue_1.tag === 17) ? [new HTMLAttr(/* Checked */ 62, [true]), new HTMLAttr(/* Checked */ 62, [true])] : ((matchValue_1.tag === 19) ? [new HTMLAttr(/* Checked */ 62, [true]), new HTMLAttr(/* Checked */ 62, [false])] : ((matchValue_1.tag === 18) ? [new HTMLAttr(/* Checked */ 62, [false]), new HTMLAttr(/* Checked */ 62, [true])] : ((matchValue_1.tag === 20) ? [new HTMLAttr(/* Checked */ 62, [false]), new HTMLAttr(/* Checked */ 62, [false])] : toFail(printf("Cannot change adder type from non-adder component"))))));
        const children_12 = [fieldLabel("Optional Ports"), table_1(empty(), ofArray([(children_4 = [(props = [["style", {
            borderStyle: "solid",
        }]], react_2.createElement("td", keyValueList(props, 1), "Cin")), (props_2 = [["style", {
            borderStyle: "solid",
        }]], (children_2 = [input_1(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([new DOMAttr(/* OnChange */ 9, [(_arg) => {
            const matchValue_2 = comp.Type;
            switch (matchValue_2.tag) {
                case 17: {
                    DrawModelType_SheetT_Model__Model_ChangeAdderComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* NbitsAdderNoCin */ 18, [matchValue_2.fields[0]]));
                    break;
                }
                case 19: {
                    DrawModelType_SheetT_Model__Model_ChangeAdderComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* NbitsAdderNoCinCout */ 20, [matchValue_2.fields[0]]));
                    break;
                }
                case 18: {
                    DrawModelType_SheetT_Model__Model_ChangeAdderComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* NbitsAdder */ 17, [matchValue_2.fields[0]]));
                    break;
                }
                case 20: {
                    DrawModelType_SheetT_Model__Model_ChangeAdderComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* NbitsAdderNoCout */ 19, [matchValue_2.fields[0]]));
                    break;
                }
                default:
                    toFail(printf("Cannot change adder type from non-adder component"));
            }
        }]), new HTMLAttr(/* Value */ 161, ["Cin"]), new HTMLAttr(/* Id */ 99, ["Cin-button"]), new HTMLAttr(/* Name */ 123, ["Cin-button"]), patternInput[0], ["style", {
            height: "15px",
            width: "15px",
        }]])])))], react_2.createElement("td", keyValueList(props_2, 1), ...children_2)))], react_2.createElement("tr", {}, ...children_4)), (children_10 = [(props_6 = [["style", {
            borderStyle: "solid",
        }]], react_2.createElement("td", keyValueList(props_6, 1), "Cout")), (props_8 = [["style", {
            borderStyle: "solid",
        }]], (children_8 = [input_1(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([new DOMAttr(/* OnChange */ 9, [(_arg_1) => {
            const matchValue_3 = comp.Type;
            switch (matchValue_3.tag) {
                case 17: {
                    DrawModelType_SheetT_Model__Model_ChangeAdderComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* NbitsAdderNoCout */ 19, [matchValue_3.fields[0]]));
                    break;
                }
                case 18: {
                    DrawModelType_SheetT_Model__Model_ChangeAdderComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* NbitsAdderNoCinCout */ 20, [matchValue_3.fields[0]]));
                    break;
                }
                case 19: {
                    DrawModelType_SheetT_Model__Model_ChangeAdderComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* NbitsAdder */ 17, [matchValue_3.fields[0]]));
                    break;
                }
                case 20: {
                    DrawModelType_SheetT_Model__Model_ChangeAdderComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* NbitsAdderNoCin */ 18, [matchValue_3.fields[0]]));
                    break;
                }
                default:
                    toFail(printf("Cannot change adder type from non-adder component"));
            }
        }]), new HTMLAttr(/* Value */ 161, ["Cout"]), new HTMLAttr(/* Id */ 99, ["Cout-button"]), new HTMLAttr(/* Name */ 123, ["Cout-button"]), patternInput[1], ["style", {
            height: "15px",
            width: "15px",
        }]])])))], react_2.createElement("td", keyValueList(props_8, 1), ...children_8)))], react_2.createElement("tr", {}, ...children_10))])), react_2.createElement("br", {})];
        return react_2.createElement("div", {}, ...children_12);
    }
    else {
        return toFail(printf("What? current project cannot be None at this point in writing Verilog Component"));
    }
}

function changeCounterType(model, comp, dispatch) {
    let children_4, props, props_2, children_2, children_10, props_6, props_8, children_8;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const sheetDispatch = (sMsg) => {
            dispatch(new Msg(/* Sheet */ 3, [sMsg]));
        };
        let patternInput;
        const matchValue_1 = comp.Type;
        patternInput = ((matchValue_1.tag === 35) ? [new HTMLAttr(/* Checked */ 62, [true]), new HTMLAttr(/* Checked */ 62, [true])] : ((matchValue_1.tag === 37) ? [new HTMLAttr(/* Checked */ 62, [true]), new HTMLAttr(/* Checked */ 62, [false])] : ((matchValue_1.tag === 36) ? [new HTMLAttr(/* Checked */ 62, [false]), new HTMLAttr(/* Checked */ 62, [true])] : ((matchValue_1.tag === 38) ? [new HTMLAttr(/* Checked */ 62, [false]), new HTMLAttr(/* Checked */ 62, [false])] : toFail(printf("Cannot change counter type from non-counter component"))))));
        const children_12 = [fieldLabel("Optional Inputs"), table_1(empty(), ofArray([(children_4 = [(props = [["style", {
            borderStyle: "solid",
        }]], react_2.createElement("td", keyValueList(props, 1), "Load")), (props_2 = [["style", {
            borderStyle: "solid",
        }]], (children_2 = [input_1(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([new DOMAttr(/* OnChange */ 9, [(_arg) => {
            const matchValue_2 = comp.Type;
            switch (matchValue_2.tag) {
                case 35: {
                    DrawModelType_SheetT_Model__Model_ChangeCounterComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* CounterNoLoad */ 36, [matchValue_2.fields[0]]));
                    break;
                }
                case 37: {
                    DrawModelType_SheetT_Model__Model_ChangeCounterComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* CounterNoEnableLoad */ 38, [matchValue_2.fields[0]]));
                    break;
                }
                case 36: {
                    DrawModelType_SheetT_Model__Model_ChangeCounterComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* Counter */ 35, [matchValue_2.fields[0]]));
                    break;
                }
                case 38: {
                    DrawModelType_SheetT_Model__Model_ChangeCounterComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* CounterNoEnable */ 37, [matchValue_2.fields[0]]));
                    break;
                }
                default:
                    toFail(printf("Cannot change adder type from non-adder component"));
            }
        }]), new HTMLAttr(/* Value */ 161, ["Load"]), new HTMLAttr(/* Id */ 99, ["Load-button"]), new HTMLAttr(/* Name */ 123, ["Load-button"]), patternInput[0], ["style", {
            height: "15px",
            width: "15px",
        }]])])))], react_2.createElement("td", keyValueList(props_2, 1), ...children_2)))], react_2.createElement("tr", {}, ...children_4)), (children_10 = [(props_6 = [["style", {
            borderStyle: "solid",
        }]], react_2.createElement("td", keyValueList(props_6, 1), "Enable")), (props_8 = [["style", {
            borderStyle: "solid",
        }]], (children_8 = [input_1(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([new DOMAttr(/* OnChange */ 9, [(_arg_1) => {
            const matchValue_3 = comp.Type;
            switch (matchValue_3.tag) {
                case 35: {
                    DrawModelType_SheetT_Model__Model_ChangeCounterComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* CounterNoEnable */ 37, [matchValue_3.fields[0]]));
                    break;
                }
                case 36: {
                    DrawModelType_SheetT_Model__Model_ChangeCounterComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* CounterNoEnableLoad */ 38, [matchValue_3.fields[0]]));
                    break;
                }
                case 37: {
                    DrawModelType_SheetT_Model__Model_ChangeCounterComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* Counter */ 35, [matchValue_3.fields[0]]));
                    break;
                }
                case 38: {
                    DrawModelType_SheetT_Model__Model_ChangeCounterComp(model.Sheet, sheetDispatch, comp.Id, new ComponentType(/* CounterNoLoad */ 36, [matchValue_3.fields[0]]));
                    break;
                }
                default:
                    toFail(printf("Cannot change adder type from non-adder component"));
            }
        }]), new HTMLAttr(/* Value */ 161, ["Enable"]), new HTMLAttr(/* Id */ 99, ["Enable-button"]), new HTMLAttr(/* Name */ 123, ["Enable-button"]), patternInput[1], ["style", {
            height: "15px",
            width: "15px",
        }]])])))], react_2.createElement("td", keyValueList(props_8, 1), ...children_8)))], react_2.createElement("tr", {}, ...children_10))])), react_2.createElement("br", {})];
        return react_2.createElement("div", {}, ...children_12);
    }
    else {
        return toFail(printf("What? current project cannot be None at this point in writing Verilog Component"));
    }
}

function makeScaleAdjustmentField(model, comp, dispatch) {
    const sheetDispatch = (sMsg) => {
        dispatch(new Msg(/* Sheet */ 3, [sMsg]));
    };
    let textw;
    const matchValue = comp.SymbolInfo;
    if (matchValue == null) {
        textw = 1;
    }
    else {
        const matchValue_1 = matchValue.HScale;
        textw = ((matchValue_1 == null) ? 1 : matchValue_1);
    }
    let texth;
    const matchValue_2 = comp.SymbolInfo;
    if (matchValue_2 == null) {
        texth = 1;
    }
    else {
        const matchValue_3 = matchValue_2.VScale;
        texth = ((matchValue_3 == null) ? 1 : matchValue_3);
    }
    const props_2 = [["style", {
        display: "flex",
        flex: "0 0 auto",
        columnGap: "12px",
    }]];
    const children = [floatFormField("Width Scale", "60px", textw, 0, (newWidth) => {
        if (newWidth < 0) {
            dispatch(new Msg(/* SetPropertiesNotification */ 83, [errorPropsNotification("A scale factor cannot be negative.")]));
        }
        else {
            DrawModelType_SheetT_Model__Model_ChangeScale(model.Sheet, sheetDispatch, comp.Id, newWidth, "horizontal");
            dispatch(Msg.ClosePropertiesNotification);
        }
    }), floatFormField("Height Scale", "60px", texth, 0, (newWidth_1) => {
        if (newWidth_1 < 0) {
            dispatch(new Msg(/* SetPropertiesNotification */ 83, [errorPropsNotification("A scale factor cannot be negative.")]));
        }
        else {
            DrawModelType_SheetT_Model__Model_ChangeScale(model.Sheet, sheetDispatch, comp.Id, newWidth_1, "vertical");
            dispatch(Msg.ClosePropertiesNotification);
        }
    })];
    return react_2.createElement("div", keyValueList(props_2, 1), ...children);
}

function makeNumberOfBitsField(model, comp, text, dispatch) {
    let patternInput;
    const matchValue = comp.Type;
    let matchResult, w, w_1;
    switch (matchValue.tag) {
        case 0: {
            matchResult = 0;
            w = matchValue.fields[0];
            break;
        }
        case 1: {
            matchResult = 0;
            w = matchValue.fields[0];
            break;
        }
        case 50: {
            matchResult = 0;
            w = matchValue.fields[0];
            break;
        }
        case 51: {
            matchResult = 0;
            w = matchValue.fields[0];
            break;
        }
        case 52: {
            matchResult = 0;
            w = matchValue.fields[0];
            break;
        }
        case 53: {
            matchResult = 0;
            w = matchValue.fields[0];
            break;
        }
        case 17: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 18: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 19: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 20: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 21: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 22: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 24: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 23: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 33: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 34: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 35: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 37: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 38: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 36: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 2: {
            matchResult = 1;
            w_1 = matchValue.fields[0];
            break;
        }
        case 25: {
            matchResult = 2;
            break;
        }
        case 28: {
            matchResult = 3;
            break;
        }
        case 6: {
            matchResult = 4;
            break;
        }
        case 47: {
            matchResult = 5;
            break;
        }
        case 5: {
            matchResult = 6;
            break;
        }
        case 7: {
            matchResult = 7;
            break;
        }
        case 46: {
            matchResult = 8;
            break;
        }
        default:
            matchResult = 9;
    }
    switch (matchResult) {
        case 0: {
            patternInput = ["Width (bits)", w, new CompSlotName(/* IO */ 1, [comp.Label])];
            break;
        }
        case 1: {
            patternInput = ["Width (bits)", w_1, CompSlotName.Buswidth];
            break;
        }
        case 2: {
            patternInput = ["Output width (bits)", matchValue.fields[0], CompSlotName.Buswidth];
            break;
        }
        case 3: {
            patternInput = ["Top (LSB) output width (bits)", matchValue.fields[0], CompSlotName.Buswidth];
            break;
        }
        case 4: {
            patternInput = ["Width (bits)", matchValue.fields[0], CompSlotName.Buswidth];
            break;
        }
        case 5: {
            patternInput = ["Width (bits)", matchValue.fields[0], CompSlotName.Buswidth];
            break;
        }
        case 6: {
            patternInput = ["Width (bits)", matchValue.fields[0], CompSlotName.Buswidth];
            break;
        }
        case 7: {
            patternInput = ["Width (bits)", matchValue.fields[0], CompSlotName.Buswidth];
            break;
        }
        case 8: {
            patternInput = ["Width (bits)", matchValue.fields[0], CompSlotName.Buswidth];
            break;
        }
        default:
            patternInput = toFail(`makeNumberOfBitsField called with invalid component: ${matchValue}`);
    }
    const slot = patternInput[2];
    const constraints = constraintsFor(slot, comp.Type);
    return paramInputField(model, patternInput[0], fromOne(), fromInt32(patternInput[1]), undefined, constraints, undefined, comp, slot, dispatch);
}

function makeNumberOfInputsField(model, comp, dispatch) {
    let patternInput;
    const matchValue = comp.Type;
    patternInput = ((matchValue.tag === 10) ? ["Number of inputs", matchValue.fields[0], matchValue.fields[1]] : toFail(`makeNumberOfInputsField called with invalid component: ${matchValue}`));
    return div(empty(), ofArray([fieldLabel(patternInput[0]), input(ofArray([new Option(/* Type */ 1, [IInputType.Number$]), new Option(/* Props */ 15, [ofArray([["style", {
        width: "60px",
    }], new HTMLAttr(/* Min */ 119, [2]), new HTMLAttr(/* Max */ 114, [Constants_maxGateInputs])])]), new Option(/* DefaultValue */ 10, [int32ToString(patternInput[2])]), new Option(/* OnChange */ 13, [(arg) => {
        const newNum = getIntEventValue(arg) | 0;
        if ((newNum >= 2) && (newNum <= Constants_maxGateInputs)) {
            DrawModelType_SheetT_Model__Model_ChangeGate(model.Sheet, (sMsg) => {
                dispatch(new Msg(/* Sheet */ 3, [sMsg]));
            }, comp.Id, patternInput[1], newNum);
        }
    }])]))]));
}

function changeMergeN(model, comp, dispatch) {
    let option_1, i, props;
    const errText = defaultArg((option_1 = model.PopupDialogData.Int, (option_1 != null) ? ((i = (option_1 | 0), ((i < 2) ? true : (i > Constants_maxSplitMergeBranches)) ? toText(`Must have between 2 and ${Constants_maxSplitMergeBranches} inputs`) : "")) : undefined), "");
    let patternInput;
    const matchValue = comp.Type;
    patternInput = ((matchValue.tag === 29) ? ["Number of inputs", matchValue.fields[0]] : toFail(printf("changeMergeN called with invalid component: %A"))(matchValue));
    const children_2 = [(props = [["style", {
        color: HighLightColor.Red,
    }]], react_2.createElement("span", keyValueList(props, 1), errText)), div(empty(), ofArray([fieldLabel(patternInput[0]), input(ofArray([new Option(/* Type */ 1, [IInputType.Number$]), new Option(/* Props */ 15, [ofArray([["style", {
        width: "60px",
    }], new HTMLAttr(/* Min */ 119, [2]), new HTMLAttr(/* Max */ 114, [Constants_maxSplitMergeBranches])])]), new Option(/* DefaultValue */ 10, [int32ToString(patternInput[1])]), new Option(/* OnChange */ 13, [(arg_1) => {
        const newNum = getIntEventValue(arg_1) | 0;
        if ((newNum >= 2) && (newNum <= Constants_maxSplitMergeBranches)) {
            DrawModelType_SheetT_Model__Model_ChangeMergeN(model.Sheet, (sMsg) => {
                dispatch(new Msg(/* Sheet */ 3, [sMsg]));
            }, comp.Id, newNum);
        }
    }])]))]))];
    return react_2.createElement("div", {}, ...children_2);
}

function changeSplitN(model, comp, dispatch) {
    let option_1, i, props, children_4, props_4;
    const errText = defaultArg((option_1 = model.PopupDialogData.Int, (option_1 != null) ? ((i = (option_1 | 0), ((i < 2) ? true : (i > Constants_maxSplitMergeBranches)) ? toText(`Must have between 2 and ${Constants_maxSplitMergeBranches} outputs`) : "")) : undefined), "");
    let patternInput;
    const matchValue = comp.Type;
    patternInput = ((matchValue.tag === 30) ? ["Number of outputs", matchValue.fields[0], matchValue.fields[1], matchValue.fields[2]] : toFail(printf("changeSplitN called with invalid component: %A"))(matchValue));
    const widths_1 = patternInput[2];
    const lsbs = patternInput[3];
    const children_7 = [(props = [["style", {
        color: HighLightColor.Red,
    }]], react_2.createElement("span", keyValueList(props, 1), errText)), div(empty(), ofArray([fieldLabel(patternInput[0]), input(ofArray([new Option(/* Type */ 1, [IInputType.Number$]), new Option(/* Props */ 15, [ofArray([["style", {
        width: "80px",
    }], new HTMLAttr(/* Min */ 119, [2]), new HTMLAttr(/* Max */ 114, [Constants_maxSplitMergeBranches])])]), new Option(/* DefaultValue */ 10, [int32ToString(patternInput[1])]), new Option(/* OnChange */ 13, [(arg_1) => {
        let lsbs_1, newNumInputs_1, matchValue_2, n_7, msbs;
        const newNum = getIntEventValue(arg_1) | 0;
        let newWidths;
        const widths_2 = widths_1;
        const newNumInputs = newNum | 0;
        const matchValue_1 = length(widths_2) | 0;
        newWidths = ((matchValue_1 > newNumInputs) ? getSlice(undefined, newNumInputs - 1, widths_2) : ((matchValue_1 < newNumInputs) ? append(widths_2, initialize(newNumInputs - matchValue_1, (_arg) => 1)) : widths_2));
        DrawModelType_SheetT_Model__Model_ChangeSplitN(model.Sheet, (sMsg) => {
            dispatch(new Msg(/* Sheet */ 3, [sMsg]));
        }, comp.Id, newNum, newWidths, (lsbs_1 = lsbs, (newNumInputs_1 = (newNum | 0), (matchValue_2 = (length(lsbs_1) | 0), (matchValue_2 > newNumInputs_1) ? getSlice(undefined, newNumInputs_1 - 1, lsbs_1) : ((matchValue_2 < newNumInputs_1) ? ((n_7 = (matchValue_2 | 0), (msbs = map2((lsb, width) => (((lsb + width) - 1) | 0), lsbs_1, truncate(n_7, newWidths)), append(lsbs_1, initialize(newNumInputs_1 - n_7, (x) => (((x + max(msbs, {
            Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
        })) + 1) | 0)))))) : lsbs_1)))));
    }])]))])), (children_4 = mapIndexed((index, defaultWidth) => {
        const defaultLsb = item(index, lsbs) | 0;
        const props_2 = [["style", {
            marginLeft: "10px",
            marginBottom: "10px",
        }]];
        const children_2 = [label_1(empty(), singleton(toText(printf("Output Port %d"))(index))), paramInputField(model, "Width", fromOne(), fromInt32(defaultWidth), undefined, constraintsFor(new CompSlotName(/* SplitNWidth */ 3, [index]), comp.Type), undefined, comp, new CompSlotName(/* SplitNWidth */ 3, [index]), dispatch), paramInputField(model, "LSB", fromZero(), fromInt32(defaultLsb), undefined, constraintsFor(new CompSlotName(/* SplitNLSB */ 4, [index]), comp.Type), undefined, comp, new CompSlotName(/* SplitNLSB */ 4, [index]), dispatch)];
        return react_2.createElement("div", keyValueList(props_2, 1), ...children_2);
    }, widths_1), (props_4 = singleton(["style", {
        marginBottom: "20px",
    }]), react_2.createElement("div", keyValueList(props_4, 1), ...children_4)))];
    return react_2.createElement("div", {}, ...children_7);
}

/**
 * Used for Input1 Component types. Make field for users to enter a default value for
 * Input1 Components when they are undriven.
 */
export function makeDefaultValueField(model, comp, dispatch) {
    let defValue_1;
    const matchValue = comp.Type;
    defValue_1 = ((matchValue.tag === 0) ? defaultArg(matchValue.fields[1], fromZero()) : toFail(printf("Other component types should not call this function.")));
    const constraints = constraintsFor(CompSlotName.InputDefault, comp.Type);
    return paramInputField(model, "Default value if input is undriven", fromZero(), defValue_1, undefined, constraints, undefined, comp, CompSlotName.InputDefault, dispatch);
}

/**
 * Used for JoinOut and JoinIn. Which channel this join uses, in the copy of the array design
 * sheet it is in. Almost always an expression in the sheet's loop variable - `i`, `i+1`, `i-1` -
 * which is what makes copy i's Join out meet copy i+1's Join in.
 */
export function makeJoinNumField(model, comp, dispatch) {
    let num;
    const matchValue = comp.Type;
    let matchResult, n;
    switch (matchValue.tag) {
        case 52: {
            matchResult = 0;
            n = matchValue.fields[1];
            break;
        }
        case 53: {
            matchResult = 0;
            n = matchValue.fields[1];
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            num = n;
            break;
        }
        default:
            num = toFail(`makeJoinNumField called on ${matchValue}, which is not a join`);
    }
    const constraints = constraintsFor(CompSlotName.JoinNum, comp.Type);
    return paramInputField(model, "Channel number", fromZero(), fromInt32(num), undefined, constraints, undefined, comp, CompSlotName.JoinNum, dispatch);
}

export function mockDispatchS(msgFun, msg) {
    let matchResult, sMsg;
    if (msg.tag === 3) {
        if (msg.fields[0].tag === 0) {
            if (msg.fields[0].fields[0].tag === 0) {
                matchResult = 0;
                sMsg = msg.fields[0].fields[0].fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            msgFun(msg);
            break;
        }
        case 1: {
            break;
        }
    }
}

export const msgToS = (arg_1) => (new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [arg_1])])]));

/**
 * Return dialog fileds used by constant, or default values
 */
export function constantDialogWithDefault(w, cText, dialog) {
    return [defaultArg(dialog.Int, w), defaultArg(dialog.Text, cText)];
}

function makeConstantValueField(model, comp, dispatch) {
    let patternInput;
    const matchValue = comp.Type;
    patternInput = ((matchValue.tag === 7) ? ["Constant value (decimal, 0x hex or 0b binary)", matchValue.fields[1]] : ((matchValue.tag === 5) ? ["Compare with (decimal, 0x hex or 0b binary)", matchValue.fields[1]] : toFail(`makeConstantValueField called on ${comp.Type}, which has no such field`)));
    const constraints = constraintsFor(new CompSlotName(/* IO */ 1, [comp.Label]), comp.Type);
    return paramInputField(model, patternInput[0], fromZero(), patternInput[1], undefined, constraints, undefined, comp, new CompSlotName(/* IO */ 1, [comp.Label]), dispatch);
}

/**
 * The properties of a constant: its width, its value, and what that value comes to.
 * 
 * Both boxes are parameter boxes and apply themselves - ParameterView.updateComponentSlots is what
 * carries a slot to the component - so this lays them out and does nothing else. It used to hold
 * the applying too, dispatching WHILE RENDERING whenever the dialog's text differed from the
 * component, which needed a read-only guard of its own to stop it looping. Nothing here dispatches
 * now, so there is nothing for a read-only sheet to undo.
 */
export function makeConstantDialog(model, comp, text, dispatch) {
    let patternInput;
    const matchValue = comp.Type;
    patternInput = ((matchValue.tag === 7) ? [matchValue.fields[0], matchValue.fields[1]] : toFail(printf("What? makeConstantDialog called on {comp.Type}")));
    const children = [makeNumberOfBitsField(model, comp, text, dispatch), react_2.createElement("br", {}), makeConstantValueField(model, comp, dispatch), constantValueMessage(patternInput[0], patternInput[1])];
    return react_2.createElement("div", {}, ...children);
}

/**
 * As makeConstantDialog, for what a bus comparator compares against.
 */
export function makeBusCompareDialog(model, comp, text, dispatch) {
    let patternInput;
    const matchValue = comp.Type;
    patternInput = ((matchValue.tag === 5) ? [matchValue.fields[0], matchValue.fields[1]] : toFail(printf("What? makeBusCompareDialog called on {comp.Type}")));
    const children = [makeNumberOfBitsField(model, comp, text, dispatch), react_2.createElement("br", {}), makeConstantValueField(model, comp, dispatch), busCompareValueMessage(patternInput[0], patternInput[1])];
    return react_2.createElement("div", {}, ...children);
}

function makeLsbBitNumberField(model, comp, dispatch) {
    let patternInput;
    const matchValue = comp.Type;
    patternInput = ((matchValue.tag === 6) ? ["Least Significant Bit number selected: lsb", fromInt32(matchValue.fields[1])] : ((matchValue.tag === 47) ? ["Compare with", matchValue.fields[1]] : toFail(`makeLsbBitNumberField called on ${comp.Type}, which has no such field`)));
    const constraints = constraintsFor(new CompSlotName(/* IO */ 1, [comp.Label]), comp.Type);
    return paramInputField(model, patternInput[0], fromZero(), patternInput[1], undefined, constraints, undefined, comp, new CompSlotName(/* IO */ 1, [comp.Label]), dispatch);
}

function describeComponent(comp, model) {
    let s, s_1, s_2, s_3, s_4, s_5, s_6, s_7, s_8, s_12, s_13, s_14, s_15, s_16, s_21, children, props_36, children_2;
    const nGateNote = (gateName) => concat("One ", gateName, " gate per bit of the input and output busses.");
    const matchValue = comp.Type;
    let matchResult, mem, mem_1, mem_2, mem_3, shiftType, shifterWidth, custom;
    switch (matchValue.tag) {
        case 48: {
            matchResult = 1;
            break;
        }
        case 54:
        case 55: {
            matchResult = 2;
            break;
        }
        case 0:
        case 1:
        case 2:
        case 4:
        case 7:
        case 49:
        case 8:
        case 10:
        case 9:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20: {
            matchResult = 3;
            break;
        }
        case 47:
        case 5: {
            matchResult = 4;
            break;
        }
        case 50: {
            matchResult = 5;
            break;
        }
        case 51: {
            matchResult = 6;
            break;
        }
        case 52: {
            matchResult = 7;
            break;
        }
        case 53: {
            matchResult = 8;
            break;
        }
        case 6: {
            matchResult = 9;
            break;
        }
        case 3: {
            matchResult = 10;
            break;
        }
        case 27: {
            matchResult = 11;
            break;
        }
        case 29: {
            matchResult = 12;
            break;
        }
        case 28: {
            matchResult = 13;
            break;
        }
        case 30: {
            matchResult = 14;
            break;
        }
        case 22: {
            matchResult = 17;
            break;
        }
        case 24: {
            matchResult = 18;
            break;
        }
        case 23: {
            matchResult = 19;
            break;
        }
        case 25: {
            matchResult = 20;
            break;
        }
        case 31: {
            matchResult = 21;
            break;
        }
        case 32: {
            matchResult = 22;
            break;
        }
        case 33: {
            matchResult = 23;
            break;
        }
        case 34: {
            matchResult = 24;
            break;
        }
        case 35:
        case 37:
        case 38:
        case 36: {
            matchResult = 25;
            break;
        }
        case 21: {
            if (matchValue.fields[1] != null) {
                matchResult = 15;
            }
            else {
                matchResult = 16;
            }
            break;
        }
        case 39: {
            matchResult = 26;
            mem = matchValue.fields[0];
            break;
        }
        case 40: {
            matchResult = 27;
            mem_1 = matchValue.fields[0];
            break;
        }
        case 41: {
            matchResult = 28;
            mem_2 = matchValue.fields[0];
            break;
        }
        case 42: {
            matchResult = 29;
            mem_3 = matchValue.fields[0];
            break;
        }
        case 46: {
            matchResult = 30;
            shiftType = matchValue.fields[2];
            shifterWidth = matchValue.fields[1];
            break;
        }
        case 26: {
            matchResult = 31;
            custom = matchValue.fields[0];
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return toFail(printf("What? Legacy RAM component types should never occur"));
        case 1:
            return toFail(printf("Legacy Input component types should never occur"));
        case 2:
            return empty();
        case 3:
            return empty();
        case 4:
            return singleton((s = "The output is one if the bus unsigned binary value is equal to the integer specified. This will display in hex on the design sheet.", s));
        case 5:
            return singleton((s_1 = "Takes one value from each copy of this array sheet and joins them into a single bus, with copy 0 in the least significant bits. The sheet gets one output of width (number of copies) x (this width).", s_1));
        case 6:
            return singleton((s_2 = "Takes one value from each copy of this array sheet, to be selected between by the multiplexers declared in the sheet\'s array settings. It adds no port of its own: each multiplexer adds a select input and an output.", s_2));
        case 7:
            return ofArray([(s_3 = "Sends this copy\'s value to the copy whose Join in has the same name and the same channel number. Where no copy takes it - at the end of a chain - it becomes an output of the array sheet.", s_3), react_2.createElement("br", {}), react_2.createElement("br", {}), (s_4 = "The channel number is usually written in terms of the loop variable, so a carry chain is a Join out numbered i+1 against a Join in numbered i.", s_4)]);
        case 8:
            return singleton((s_5 = "Takes this copy\'s value from the copy whose Join out has the same name and the same channel number. Where no copy sends it - at the start of a chain - it becomes an input of the array sheet.", s_5));
        case 9:
            return ofArray([(s_6 = "The output is the subrange [width+lsb-1..lsb] of the input bits. If width = 1 this selects one bit. Error if the input has less than width + lsb bits.", s_6), react_2.createElement("br", {}), react_2.createElement("br", {}), (s_7 = "Note that the output bit(s) are numbered from 0 even if the input range has LS bit number > 0. The input range selected for output is displayed in brackets on the symbol.", s_7)]);
        case 10:
            return ofArray([(s_8 = "Net labels with the same name are one net. Each label has input on left and output on right. No output connection is required from a net. Since a net represents one wire or bus, exactly one input connection is required. Net labels can be used:", s_8), react_2.createElement("br", {}), "To name wires and document designs.", react_2.createElement("br", {}), "To join inputs and outputs without wires, in place of a long connection or one driving many inputs.", react_2.createElement("br", {}), "To prevent an unused output from giving an error."]);
        case 11:
            return singleton((s_12 = "Merge two busses of width n and m into a single bus of width n+m. The bit numbers of the whole and each branch are shown when the component is connected.", s_12));
        case 12:
            return singleton((s_13 = "Merge N busses of various widths into a single bus. The bit numbers of the whole and each branch are shown when the component is connected.", s_13));
        case 13:
            return singleton((s_14 = "Split a bus of width n+m exactly into two non-overlapping busses of width n and m. The bit numbers of the whole and each branch are shown when the component is connected.", s_14));
        case 14:
            return singleton((s_15 = "Split a bus into N output busses of various widths. The output busses may overlap. The output busses need not include all of the input bits", s_15));
        case 15:
            return singleton((s_16 = "Returns the low bits of the product - as many as the busses are wide. For those bits, signed and unsigned multiplication are identical.", s_16));
        case 16:
            return singleton(nGateNote("Xor"));
        case 17:
            return singleton(nGateNote("And"));
        case 18:
            return singleton(nGateNote("Or"));
        case 19:
            return singleton(nGateNote("Not"));
        case 20:
            return singleton((s_21 = "Every bit of the output bus is the same as the 1-bit input. Used to implement sign extension and shift operations.", s_21));
        case 21:
            return singleton(clockNote);
        case 22:
            return singleton(concat("If the enable signal is high the state of the D-flip-flop will be updated at the next clock cycle. ", clockNote));
        case 23:
            return singleton(clockNote);
        case 24:
            return singleton(concat("If the enable signal is high the state of the Register will be updated at the next clock cycle. ", clockNote));
        case 25:
            return singleton(concat("If the enable signal is high the state of the counter will be updated at the next clock cycle, taking either the value of input d (when load is enabled) or the value of out+1 (if load is disabled). ", clockNote));
        case 26:
            return ofArrayWithTail(["The output is updated as soon as the address changes.", react_2.createElement("br", {}), react_2.createElement("br", {})], memoryFacts(mem, comp.Type, model));
        case 27:
            return ofArrayWithTail([concat("The output is updated only after a clock tick. ", clockNote), react_2.createElement("br", {}), react_2.createElement("br", {})], memoryFacts(mem_1, comp.Type, model));
        case 28:
            return ofArrayWithTail([concat("At every clock tick the RAM can read and optionally write the content of the memory location selected by the address. If the write signal is high, the content of the selected location is set to the value of data-in. In cycle 0 data-out is 0, otherwise data-out is the contents of the location addressed in the previous cycle, before any optional write. ", clockNote), react_2.createElement("br", {}), react_2.createElement("br", {})], memoryFacts(mem_2, comp.Type, model));
        case 29:
            return ofArrayWithTail([concat("At every clock tick, optionally write the content of the memory location selected by the address. If the write signal is high, the content of the selected location is set to the value of data-in. data-out is the contents of the location addressed by the current cycle address. ", clockNote), react_2.createElement("br", {}), react_2.createElement("br", {})], memoryFacts(mem_3, comp.Type, model));
        case 30: {
            const patternInput = (shiftType.tag === 1) ? ["LSR (logical shift right)", "bits shifted in are zero."] : ((shiftType.tag === 2) ? ["ASR (arithmetic shift right)", "the sign bit is replicated into the bits shifted in."] : ["LSL (logical shift left)", "bits shifted in are zero."]);
            return ofArray([(children = [concat("Shift kind: ", patternInput[0], ".")], react_2.createElement("b", {}, ...children)), react_2.createElement("br", {}), react_2.createElement("br", {}), `Shifts the IN bus by the number of positions given on the ${shifterWidth} bit SHIFT input: ${patternInput[1]} Shifting by the bus width or more clears the output, or fills it with the sign bit for an arithmetic shift.`]);
        }
        default: {
            const matchValue_1 = custom.Description;
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                const description = matchValue_1;
                return ofArray([(props_36 = [["style", {
                    color: "grey",
                    fontSize: "11px",
                }]], (children_2 = [concat("Description of sheet ", custom.Name, ":")], react_2.createElement("p", keyValueList(props_36, 1), ...children_2))), react_2.createElement("p", {}, description)]);
            }
        }
    }
}

function makePortSummary(model, custom) {
    let patternInput;
    const matchValue = model.CurrentProj;
    patternInput = ((matchValue != null) ? defaultArg(signatureOfInstance(getUpdatedLoadedComponents(matchValue, model).LoadedComponents, paramBindingsOfModel(model), custom.Name, defaultArg(custom.ParameterBindings, empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }))), [custom.InputLabels, custom.OutputLabels]) : [custom.InputLabels, custom.OutputLabels]);
    const outputLabels = patternInput[1];
    const inputLabels = patternInput[0];
    const group = (name, labels) => {
        let children_2;
        if (isEmpty(labels)) {
            return defaultOf();
        }
        else {
            const props_4 = [["style", {
                display: "flex",
                marginBottom: "2px",
            }]];
            const children_4 = [react_2.createElement("span", {
                className: "portGroupLabel",
            }, name), (children_2 = [StringModule_Concat("   ", map((tupledArg) => {
                const label = tupledArg[0];
                const width = tupledArg[1] | 0;
                if (width <= 1) {
                    return label;
                }
                else {
                    return `${label}(${width - 1}:0)`;
                }
            }, labels))], react_2.createElement("span", {}, ...children_2))];
            return react_2.createElement("div", keyValueList(props_4, 1), ...children_4);
        }
    };
    let matchResult, ins, outs;
    if (isEmpty(inputLabels)) {
        if (isEmpty(outputLabels)) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
            ins = inputLabels;
            outs = outputLabels;
        }
    }
    else {
        matchResult = 1;
        ins = inputLabels;
        outs = outputLabels;
    }
    switch (matchResult) {
        case 0:
            return defaultOf();
        default: {
            const props_6 = [["style", {
                marginBottom: "10px",
            }]];
            const children_6 = [fieldLabel("Ports"), group("in", ins), group("out", outs)];
            return react_2.createElement("div", keyValueList(props_6, 1), ...children_6);
        }
    }
}

function makeExtraInfo(model, comp, text, dispatch) {
    const matchValue = comp.Type;
    let matchResult, mem;
    switch (matchValue.tag) {
        case 0: {
            matchResult = 0;
            break;
        }
        case 10: {
            matchResult = 1;
            break;
        }
        case 29: {
            matchResult = 2;
            break;
        }
        case 1:
        case 22:
        case 24:
        case 23:
        case 25:
        case 21:
        case 2:
        case 46:
        case 50:
        case 51: {
            matchResult = 3;
            break;
        }
        case 52:
        case 53: {
            matchResult = 4;
            break;
        }
        case 17:
        case 18:
        case 19:
        case 20: {
            matchResult = 5;
            break;
        }
        case 28: {
            matchResult = 6;
            break;
        }
        case 30: {
            matchResult = 7;
            break;
        }
        case 33:
        case 34: {
            matchResult = 8;
            break;
        }
        case 35:
        case 37:
        case 38:
        case 36: {
            matchResult = 9;
            break;
        }
        case 6: {
            matchResult = 10;
            break;
        }
        case 47: {
            matchResult = 11;
            break;
        }
        case 5: {
            matchResult = 12;
            break;
        }
        case 7: {
            matchResult = 13;
            break;
        }
        case 11: {
            matchResult = 14;
            break;
        }
        case 26: {
            matchResult = 16;
            break;
        }
        case 39: {
            matchResult = 15;
            mem = matchValue.fields[0];
            break;
        }
        case 40: {
            matchResult = 15;
            mem = matchValue.fields[0];
            break;
        }
        case 41: {
            matchResult = 15;
            mem = matchValue.fields[0];
            break;
        }
        case 42: {
            matchResult = 15;
            mem = matchValue.fields[0];
            break;
        }
        default:
            matchResult = 17;
    }
    switch (matchResult) {
        case 0: {
            const children = [makeNumberOfBitsField(model, comp, text, dispatch), makeDefaultValueField(model, comp, dispatch)];
            return react_2.createElement("div", {}, ...children);
        }
        case 1: {
            const children_2 = [makeNumberOfInputsField(model, comp, dispatch)];
            return react_2.createElement("div", {}, ...children_2);
        }
        case 2: {
            const children_4 = [changeMergeN(model, comp, dispatch)];
            return react_2.createElement("div", {}, ...children_4);
        }
        case 3:
            return makeNumberOfBitsField(model, comp, text, dispatch);
        case 4: {
            const children_6 = [makeNumberOfBitsField(model, comp, text, dispatch), makeJoinNumField(model, comp, dispatch)];
            return react_2.createElement("div", {}, ...children_6);
        }
        case 5: {
            const children_8 = [makeNumberOfBitsField(model, comp, text, dispatch), changeAdderType(model, comp, dispatch)];
            return react_2.createElement("div", {}, ...children_8);
        }
        case 6:
            return makeNumberOfBitsField(model, comp, text, dispatch);
        case 7: {
            const children_10 = [changeSplitN(model, comp, dispatch)];
            return react_2.createElement("div", {}, ...children_10);
        }
        case 8:
            return makeNumberOfBitsField(model, comp, text, dispatch);
        case 9: {
            const children_12 = [makeNumberOfBitsField(model, comp, text, dispatch), changeCounterType(model, comp, dispatch)];
            return react_2.createElement("div", {}, ...children_12);
        }
        case 10: {
            const children_14 = [makeNumberOfBitsField(model, comp, text, dispatch), makeLsbBitNumberField(model, comp, dispatch)];
            return react_2.createElement("div", {}, ...children_14);
        }
        case 11: {
            const children_16 = [makeNumberOfBitsField(model, comp, text, dispatch), makeLsbBitNumberField(model, comp, dispatch)];
            return react_2.createElement("div", {}, ...children_16);
        }
        case 12:
            return makeBusCompareDialog(model, comp, text, dispatch);
        case 13:
            return makeConstantDialog(model, comp, text, dispatch);
        case 14:
            return button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_3(/* OnClick */ 18, [(_arg) => {
                dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, _arg_1) => {
                    DrawModelType_SheetT_Model__Model_ChangeReversedInputs(model_1.Sheet, (arg) => {
                        dispatch(new Msg(/* Sheet */ 3, [arg]));
                    }, comp.Id);
                }, dispatch]));
            }])]), singleton("Reverse Inputs"));
        case 15: {
            const children_18 = [makeMemoryWidthFields(model, comp, mem, dispatch), memoryActions(mem, comp.Id, comp.Type, model, dispatch)];
            return react_2.createElement("div", {}, ...children_18);
        }
        case 16: {
            const custom = matchValue.fields[0];
            let openSheetButton;
            const matchValue_1 = custom.Form;
            let matchResult_1;
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 1) {
                    matchResult_1 = 0;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    openSheetButton = defaultOf();
                    break;
                }
                default:
                    openSheetButton = button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsInfo]), Option_3.IsLight, new Option_3(/* OnClick */ 18, [(_arg_2) => {
                        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_2, dispatch_2) => {
                            const matchValue_2 = model_2.CurrentProj;
                            if (matchValue_2 == null) {
                            }
                            else {
                                const proj = matchValue_2;
                                openFileInProject(custom.Name, proj, model_2, dispatch_2);
                                dispatch_2(new Msg(/* UpdateUISheetTrail */ 4, [(trail) => cons(proj.OpenFileName, trail)]));
                            }
                        }, dispatch]));
                    }])]), singleton(concat("Open sheet ", custom.Name)));
            }
            const children_20 = [makeParamBindingEntryBoxes(model, comp, custom, dispatch), makePortSummary(model, custom), openSheetButton, makeVerilogEditButton(model, custom, dispatch), makeVerilogDeleteButton(model, custom, dispatch)];
            return react_2.createElement("div", {}, ...children_20);
        }
        default:
            return react_2.createElement("div", {});
    }
}

function makeAboutSection(model, comp, dispatch) {
    let props_2;
    let appearance;
    const matchValue = comp.Type;
    let matchResult;
    if (matchValue.tag === 26) {
        if (matchValue.fields[0].Form != null) {
            if (matchValue.fields[0].Form.tag === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            appearance = empty();
            break;
        }
        case 1: {
            appearance = singleton(makeScaleAdjustmentField(model, comp, dispatch));
            break;
        }
        default:
            appearance = empty();
    }
    const matchValue_1 = append(describeComponent(comp, model), appearance);
    if (isEmpty(matchValue_1)) {
        return defaultOf();
    }
    else {
        const props_4 = [new HTMLAttr(/* Open */ 125, [false]), ["style", {
            marginTop: "15px",
        }]];
        const children_4 = [react_2.createElement("summary", keyValueList([menuLabelStyle], 1), "About this component"), (props_2 = [["style", {
            fontSize: "12px",
            lineHeight: "1.35",
        }]], react_2.createElement("div", keyValueList(props_2, 1), ...matchValue_1))];
        return react_2.createElement("details", keyValueList(props_4, 1), ...children_4);
    }
}

export function viewSelectedComponent(model, dispatch) {
    let descr;
    const dispatchWithModel = (func) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [uncurry2(func), dispatch]));
    };
    const checkIfLabelIsUnique = (chars, symbols) => {
        if (exists((s) => (s.Component.Label === chars), symbols)) {
            return new FSharpResult$2(/* Error */ 1, [Constants_labelUniqueMess]);
        }
        else {
            return new FSharpResult$2(/* Ok */ 0, [chars]);
        }
    };
    let allowNoLabel;
    const matchValue_1 = model.Sheet.SelectedComponents;
    let matchResult, cid;
    if (!isEmpty(matchValue_1)) {
        if (isEmpty(tail(matchValue_1))) {
            matchResult = 0;
            cid = head(matchValue_1);
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_2 = tryFind(cid, model.Sheet.Wire.Symbol.Symbols);
            let matchResult_1;
            if (matchValue_2 != null) {
                switch (matchValue_2.Component.Type.tag) {
                    case 27:
                    case 28:
                    case 6:
                    case 4: {
                        matchResult_1 = 0;
                        break;
                    }
                    default:
                        matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    allowNoLabel = true;
                    break;
                }
                default:
                    allowNoLabel = false;
            }
            break;
        }
        default:
            allowNoLabel = false;
    }
    const formatLabelText = (txt, compId) => {
        let allowedDotPos;
        const matchValue_3 = extractComponent(model.Sheet.Wire.Symbol, compId).Type;
        allowedDotPos = ((matchValue_3.tag === 26) ? matchValue_3.fields[0].Name.length : -1);
        const chars_1 = txt.toLocaleUpperCase();
        const symbols_2 = map((tuple) => tuple[1], filter((tupledArg) => !equals(tupledArg[0], compId), toList(model.Sheet.Wire.Symbol.Symbols)));
        const badChars = StringModule_Concat("", map_1((value) => value, map_1((tuple_1) => tuple_1[1], filter_1((tupledArg_1) => {
            let ch_1;
            const ch = tupledArg_1[1];
            if (!((ch_1 = ch, isLetterOrDigit(ch_1) ? true : (ch_1 === "_")))) {
                if (ch !== ".") {
                    return true;
                }
                else {
                    return tupledArg_1[0] !== allowedDotPos;
                }
            }
            else {
                return false;
            }
        }, indexed(chars_1.split(""))))));
        const matchValue_4 = StringModule_Length(chars_1) | 0;
        if (matchValue_4 === 0) {
            if (allowNoLabel) {
                return new FSharpResult$2(/* Ok */ 0, [""]);
            }
            else {
                return new FSharpResult$2(/* Error */ 1, ["Empty label is not allowed for this component"]);
            }
        }
        else if (!StringModule_StartsWithLetter(chars_1)) {
            return new FSharpResult$2(/* Error */ 1, ["Labels must start with a character"]);
        }
        else if ((badChars.indexOf(".") >= 0) && (allowedDotPos > 0)) {
            return new FSharpResult$2(/* Error */ 1, ["Custom Component labels can only contain a \'.\' immediately after the name"]);
        }
        else if (badChars.indexOf(".") >= 0) {
            return new FSharpResult$2(/* Error */ 1, ["Labels of normal components can only contain letters and digits and underscores, not \'.\'"]);
        }
        else if (badChars !== "") {
            return new FSharpResult$2(/* Error */ 1, [concat("Labels can only contain letters and digits, not \'", badChars, "\'")]);
        }
        else {
            const matchValue_5 = FSharpMap__get_Item(model.Sheet.Wire.Symbol.Symbols, compId).Component.Type;
            switch (matchValue_5.tag) {
                case 3:
                    return checkIfLabelIsUnique(chars_1, filter((s_2) => !equals(s_2.Component.Type, ComponentType.IOLabel), symbols_2));
                case 52:
                case 53:
                    return new FSharpResult$2(/* Ok */ 0, [chars_1]);
                default:
                    return checkIfLabelIsUnique(chars_1, symbols_2);
            }
        }
    };
    let react_1;
    let react;
    const matchValue_6 = model.Sheet.SelectedComponents;
    let matchResult_2, compId_1;
    if (!isEmpty(matchValue_6)) {
        if (isEmpty(tail(matchValue_6))) {
            matchResult_2 = 0;
            compId_1 = head(matchValue_6);
        }
        else {
            matchResult_2 = 1;
        }
    }
    else {
        matchResult_2 = 1;
    }
    switch (matchResult_2) {
        case 0: {
            const comp_1 = displayedComponent(model.Sheet.Wire.Symbol, compId_1);
            let defaultText;
            const matchValue_7 = model.PopupDialogData.Text;
            defaultText = ((matchValue_7 != null) ? matchValue_7 : comp_1.Label);
            const label$0027 = formatLabelText(defaultText, compId_1);
            const labelText = (label$0027.tag === 1) ? defaultText : label$0027.fields[0];
            let required;
            const matchValue_8 = comp_1.Type;
            switch (matchValue_8.tag) {
                case 28:
                case 27:
                case 6:
                case 4: {
                    required = false;
                    break;
                }
                default:
                    required = true;
            }
            const isBad = model.PopupDialogData.BadLabel ? ((label$0027.tag === 1) ? label$0027.fields[0] : undefined) : undefined;
            let nameLabel;
            const matchValue_9 = comp_1.Type;
            let matchResult_3;
            if (matchValue_9.tag === 26) {
                if (matchValue_9.fields[0].Form != null) {
                    if (matchValue_9.fields[0].Form.tag === 1) {
                        matchResult_3 = 0;
                    }
                    else {
                        matchResult_3 = 1;
                    }
                }
                else {
                    matchResult_3 = 1;
                }
            }
            else {
                matchResult_3 = 2;
            }
            switch (matchResult_3) {
                case 0: {
                    nameLabel = "Name";
                    break;
                }
                case 1: {
                    nameLabel = "Instance name";
                    break;
                }
                default:
                    nameLabel = "Name";
            }
            const props = [new Prop(/* Key */ 0, [toString(comp_1.Id)])];
            const children = [makeComponentHeader(comp_1), textFormField(required, nameLabel, defaultText, isBad, (text_1) => {
                const matchValue_10 = formatLabelText(text_1, compId_1);
                if (matchValue_10.tag === 0) {
                    const label = matchValue_10.fields[0];
                    setComponentLabel(model, (sMsg) => {
                        dispatch(new Msg(/* Sheet */ 3, [sMsg]));
                    }, comp_1, label);
                    dispatch(new Msg(/* SetPopupDialogText */ 52, [label]));
                    dispatch(new Msg(/* SetPopupDialogBadLabel */ 54, [false]));
                }
                else {
                    dispatch(new Msg(/* SetPopupDialogBadLabel */ 54, [true]));
                    dispatch(new Msg(/* SetPopupDialogText */ 52, [text_1]));
                }
                dispatch(new Msg(/* ReloadSelectedComponent */ 87, [model.LastUsedDialogWidth]));
            }), makeExtraInfo(model, comp_1, labelText, dispatch), makeAboutSection(model, comp_1, dispatch)];
            react = react_2.createElement("div", keyValueList(props, 1), ...children);
            break;
        }
        default: {
            const matchValue_11 = model.CurrentProj;
            if (matchValue_11 == null) {
                react = defaultOf();
            }
            else {
                const proj = matchValue_11;
                const sheetName = proj.OpenFileName;
                const sheetDescription = find((ldc) => (ldc.Name === sheetName), proj.LoadedComponents).Description;
                const descriptionButton = (sheetDescription != null) ? button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsInfo]), new Option_3(/* OnClick */ 18, [(_arg_2) => {
                    dispatchWithModel((model_2) => ((_arg_3) => {
                        createSheetDescriptionPopup(model_2, sheetDescription, sheetName, dispatch);
                    }));
                }])]), singleton("Edit Description")) : button(ofArray([new Option_3(/* Color */ 0, [Color_IColor.IsSuccess]), new Option_3(/* OnClick */ 18, [(_arg) => {
                    dispatchWithModel((model_1) => ((_arg_1) => {
                        createSheetDescriptionPopup(model_1, undefined, sheetName, dispatch);
                    }));
                }])]), singleton("Add Description"));
                const children_4 = [fieldLabel("Sheet Description"), (sheetDescription != null) ? ((descr = sheetDescription, react_2.createElement("p", {}, descr))) : defaultOf(), react_2.createElement("br", {}), descriptionButton, react_2.createElement("br", {}), react_2.createElement("br", {}), viewArraySettings(model, dispatch), viewParameters(model, dispatch)];
                react = react_2.createElement("div", {}, ...children_4);
            }
        }
    }
    if (openSheetIsReadOnly(model)) {
        const props_12 = [new HTMLAttr(/* Disabled */ 79, [true]), ["style", {
            border: "none",
            padding: "0",
            margin: "0",
            minWidth: "0",
            opacity: "0.85",
        }]];
        react_1 = react_2.createElement("fieldset", keyValueList(props_12, 1), react);
    }
    else {
        react_1 = react;
    }
    const props_14 = [["style", {
        flex: "1 1 auto",
        minHeight: "0px",
        overflowY: "auto",
    }]];
    return react_2.createElement("div", keyValueList(props_14, 1), react_1);
}

